var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqHardstandingGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    fill: "#ADAAAA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12.0435,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    fill: "#ADAAAA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7.52173,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    fill: "#ADAAAA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5652,
    y: 16.5652,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    fill: "#ADAAAA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5652,
    y: 25.6087,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    fill: "#ADAAAA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5652,
    y: 21.087,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    fill: "#ADAAAA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4348,
    y: 16.5652,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    transform: "rotate(90 15.4348 16.5652)",
    fill: "#ADAAAA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3913,
    y: 16.5652,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    transform: "rotate(90 6.3913 16.5652)",
    fill: "#ADAAAA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9131,
    y: 16.5652,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    transform: "rotate(90 10.9131 16.5652)",
    fill: "#ADAAAA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    transform: "rotate(90 29 3)",
    fill: "#ADAAAA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9565,
    y: 3,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    transform: "rotate(90 19.9565 3)",
    fill: "#ADAAAA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4783,
    y: 3,
    width: 12.4348,
    height: 3.3913,
    rx: 0.5,
    transform: "rotate(90 24.4783 3)",
    fill: "#ADAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqHardstandingGrey);
export default __webpack_public_path__ + "static/media/req_hardstanding_grey.98c3e2926237fa89efc642acd15cbe3f.svg";
export { ForwardRef as ReactComponent };